const topics = [
  { name: '明星塌房', count: '3,247万', hot: true, icon: 'ri-alert-line' },
  { name: '网红翻车', count: '2,891万', hot: true, icon: 'ri-error-warning-line' },
  { name: '娱乐圈八卦', count: '2,563万', hot: true, icon: 'ri-chat-smile-2-line' },
  { name: '社会事件', count: '1,982万', hot: false, icon: 'ri-global-line' },
  { name: '直播带货', count: '1,745万', hot: false, icon: 'ri-shopping-cart-line' },
  { name: '选秀内幕', count: '1,523万', hot: false, icon: 'ri-music-line' },
  { name: '恋爱实锤', count: '1,298万', hot: false, icon: 'ri-heart-pulse-line' },
  { name: '行业黑幕', count: '1,056万', hot: false, icon: 'ri-shield-flash-line' },
  { name: '法律维权', count: '874万', hot: false, icon: 'ri-scales-line' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">话题广场</h2>
            <p className="text-sm text-foreground-500">热门话题标签，点击探索你感兴趣的吃瓜方向</p>
          </div>
          <div className="flex flex-wrap justify-center gap-3">
            {topics.map((topic, i) => (
              <a
                key={i}
                href="#cards"
                className={`inline-flex items-center gap-2.5 px-5 py-3 rounded-lg border transition-all duration-200 cursor-pointer group ${
                  topic.hot
                    ? 'bg-primary-500/10 border-primary-500/20 hover:bg-primary-500/20'
                    : 'bg-background-100 border-background-300/40 hover:border-background-300/70 hover:bg-background-200/60'
                }`}
              >
                <div className={`w-8 h-8 flex items-center justify-center rounded-md ${
                  topic.hot ? 'bg-primary-500/20' : 'bg-secondary-500/15'
                }`}>
                  <i className={`${topic.icon} text-sm ${topic.hot ? 'text-primary-400' : 'text-secondary-400'}`}></i>
                </div>
                <div className="text-left">
                  <span className={`text-sm font-medium block ${topic.hot ? 'text-primary-400' : 'text-foreground-700'}`}>
                    {topic.name}
                  </span>
                  <span className="text-xs text-foreground-400">{topic.count}热度</span>
                </div>
                {topic.hot && (
                  <span className="text-[10px] px-1.5 py-0.5 rounded-full bg-primary-500 text-background-50">HOT</span>
                )}
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}